import HTMLParser from 'html-react-parser';
import { getImage } from '../../utils/event';

import Button from '../buttons/Button';
import LinkButton from '../buttons/LinkButton';
import Calendar from './Calendar';
import EventPrice from './EventPrice';

const DetailCardEvent = ({ event }) => {
  const init = new Date(event.initDate);

  const { image, description, eventCategories } = event;

  return (
    <article className="c-card-event">
      <Calendar date={init} />
      <div className="c-card-event__info-container">
        <h1 className="c-card-event__title">{event.title}</h1>

        <span className="c-card-event__address">
          {eventCategories.map((category) => (
            <span className="c-card-event__category">{category.category}</span>
          ))}
        </span>
        <p className="c-card-event__description">{HTMLParser(description)}</p>
        <div className="c-card-event__buttons-container">
          {event.eventTicketsLink && (
            <Button
              isActive
              onClick={() => window.open(event.eventTicketsLink)}>
              Incripción/Entradas
            </Button>
          )}
          {event.eventLink && (
            <LinkButton
              className="c-card-event__web"
              href={event.eventLink}
              target="_blank"
              rel="noopener noreferrer">
              Web
            </LinkButton>
          )}
          <EventPrice enableTooltip tickets={event.eventTickets} />
        </div>
      </div>
      <div
        className="c-card-event__image--big"
        style={{
          background: `url(${getImage(image)})`,
        }}></div>
    </article>
  );
};

export default DetailCardEvent;
